/**
 * NavBar
 * Created by zhangdanyang5 on 2018/10/26.
 */
import { StyleSheet } from 'react-native';
import { pt, px } from '../../../common/utils';

export default StyleSheet.create({
    container: {
        backgroundColor: 'transparent'
    },
    nav_wrap: {
        height: pt(44),
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    border: {
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,.1)',
    },
    btn_wrap: {
        width: pt(44),
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    btn_wrap_circle: {
        marginHorizontal: pt(7),
        height: pt(30),
        width: pt(30),
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: pt(15),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    center: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    nav_tit: {
        fontSize: pt(18),
        textAlign: 'center',
        flex: 1
    },
    back: {
        width: pt(13),
        height: pt(13),
        marginLeft: pt(6),
        borderLeftWidth: pt(1.5),
        borderBottomWidth: pt(1.5),
        // borderRadius: pt(1),
        // borderBottomLeftRadius: pt(0.5),
        // borderTopLeftRadius: pt(0.5),
        // borderBottomRightRadius: pt(0.5),
        transform: [{ rotate: '45deg' }]
    },
    more_points: {
        width: pt(4),
        height: pt(4),
        borderRadius: pt(2),
        marginHorizontal: pt(1.5),
        backgroundColor: '#fff'
    }
});
